import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { AppSettings } from '../../PRE-LOAD/app-settings';

import { Observable } from 'rxjs';
import { E2eService } from './e2e.service';

interface MappingItem {
    query: string;
    path: string;
    method: string;
}

@Injectable()
export class HttpE2eInterceptor implements HttpInterceptor {
    failOnMappings: MappingItem[] = [
        {
            query: 'models',
            path: `api/retailers/${this.appSettings.externalReferenceId}/models`,
            method: 'GET'
        },
        {
            query: 'availability',
            path: 'api/availability',
            method: 'GET'
        },
        {
            query: 'reservation',
            path: 'api/bookings',
            method: 'POST'
        },
        {
            query: 'submitcancellation',
            path: 'api/bookings',
            method: 'PATCH'
        },
        {
            query: 'getcancellation',
            path: 'api/bookings',
            method: 'GET'
        }
    ];

    constructor(
        private appSettings: AppSettings,
        private e2eService: E2eService
    ) { }


    /**
     * @description Intercepts HTTP requests and adds e2e headers if present.
     *
     * In order to facilitate end to end testing, the backend API is configured
     * to accept headers that force errors. This interceptor allows the test scripts
     * to add headers by using information passed in query params.
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Check to see if the query params match one of the routes described.
        const fail = this.failOnMappings.find(map => {
            return map.query === this.e2eService.failConditions.failOn &&
                request.url.includes(map.path) &&
                request.method === map.method;
        });

        // If we didnt match on a described route or we do not have a failWith value then
        // we cannot procees and we'll end the methof by calling next.handle() with the original
        // request.
        if (!fail || !this.e2eService.failConditions.failWith) {
            return next.handle(request);
        }

        // If we've made if this far then clone the request and set the header.
        const req = request.clone({
            headers: request.headers.set('x-test-statuscode', this.e2eService.failConditions.failWith)
        });

        // End by returning the new request.
        return next.handle(req);
    }
}
